var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoodPrettyGood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "url(#paint0_radial_40_49823)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 16,
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2727 17.6313C17.2727 19.6494 15.6363 21.2858 13.6182 21.2858C11.6 21.2858 9.96362 19.6494 9.96362 17.6313C9.96362 15.6131 11.6 13.9767 13.6182 13.9767C15.6545 13.9585 17.2727 15.6131 17.2727 17.6313Z",
    fill: "#F5825E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0181 17.1956C18.0181 19.2137 16.3817 20.8501 14.3635 20.8501C12.3453 20.8501 10.709 19.2137 10.709 17.1956C10.709 15.1774 12.3453 13.541 14.3635 13.541C16.3817 13.541 18.0181 15.1774 18.0181 17.1956Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0181 17.1962C16.0181 18.1234 15.2726 18.8689 14.3635 18.8689C13.4544 18.8689 12.709 18.1234 12.709 17.1962C12.709 16.2689 13.4544 15.5234 14.3635 15.5234C15.2726 15.5416 16.0181 16.2871 16.0181 17.1962Z",
    fill: "#14110E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7453 16.4511C13.7453 16.8693 13.3998 17.2148 12.9817 17.2148C12.5635 17.2148 12.218 16.8693 12.218 16.4511C12.218 16.033 12.5635 15.6875 12.9817 15.6875C13.3998 15.6875 13.7453 16.0148 13.7453 16.4511Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4364 17.6313C29.4364 19.6494 27.8 21.2858 25.7819 21.2858C23.7637 21.2858 22.1273 19.6494 22.1273 17.6313C22.1273 15.6131 23.7637 13.9767 25.7819 13.9767C27.8 13.9585 29.4364 15.6131 29.4364 17.6313Z",
    fill: "#F5825E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1637 17.1956C30.1637 19.2137 28.5273 20.8501 26.5092 20.8501C24.491 20.8501 22.8546 19.2137 22.8546 17.1956C22.8546 15.1774 24.491 13.541 26.5092 13.541C28.5273 13.541 30.1637 15.1774 30.1637 17.1956Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2909 17.196C28.2909 18.1415 27.5272 18.9233 26.5818 18.9233C25.6363 18.9233 24.8727 18.1597 24.8727 17.196C24.8727 16.2506 25.6363 15.4688 26.5818 15.4688C27.5272 15.4869 28.2909 16.2506 28.2909 17.196Z",
    fill: "#14110E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9273 16.4146C25.9273 16.851 25.5818 17.1964 25.1455 17.1964C24.7091 17.1964 24.3636 16.851 24.3636 16.4146C24.3636 15.9783 24.7091 15.6328 25.1455 15.6328C25.5818 15.6328 25.9273 15.9783 25.9273 16.4146Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M14.8364 25.0871C14.8364 27.3053 13.0364 29.1235 10.8182 29.1235C8.60005 29.1235 6.80005 27.3235 6.80005 25.0871C6.80005 22.869 8.60005 21.0508 10.8182 21.0508C13.0364 21.0508 14.8364 22.8508 14.8364 25.0871Z",
    fill: "url(#paint1_radial_40_49823)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M33.3819 25.0871C33.3819 27.3053 31.5819 29.1235 29.3638 29.1235C27.1456 29.1235 25.3456 27.3235 25.3456 25.0871C25.3456 22.869 27.1456 21.0508 29.3638 21.0508C31.5819 21.0508 33.3819 22.8508 33.3819 25.0871Z",
    fill: "url(#paint2_radial_40_49823)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3091 12.397C14.9091 11.3061 12.8546 11.1789 11.6728 12.6698C11.4182 12.9789 11.8909 13.397 12.1455 13.088C13.1091 11.8698 14.7637 11.9789 15.8909 12.8698C16.2182 13.1061 16.6364 12.6516 16.3091 12.397Z",
    fill: "#F5825E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7818 11.9244C15.3818 10.8335 13.3272 10.7062 12.1454 12.1971C11.8909 12.5062 12.3636 12.9244 12.6181 12.6153C13.5818 11.3971 15.2363 11.5062 16.3636 12.3971C16.6909 12.6335 17.109 12.1789 16.7818 11.9244Z",
    fill: "#3B0523"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2182 12.397C26.8182 11.3061 24.7636 11.1789 23.5818 12.6698C23.3273 12.9789 23.8 13.397 24.0545 13.088C25.0182 11.8698 26.6727 11.9789 27.8 12.8698C28.1273 13.1061 28.5454 12.6516 28.2182 12.397Z",
    fill: "#F5825E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6908 11.9244C27.2908 10.8335 25.2363 10.7062 24.0545 12.1971C23.7999 12.5062 24.2726 12.9244 24.5272 12.6153C25.4908 11.3971 27.1454 11.5062 28.2726 12.3971C28.5999 12.6335 29.0181 12.1789 28.6908 11.9244Z",
    fill: "#3B0523"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M8.98563 24.6146C15.9493 28.2327 24.6402 28.6691 31.6038 24.8146C31.822 24.6873 32.0402 25.0327 31.8038 25.16C24.7129 29.0873 15.8765 28.6509 8.78563 24.96C8.54926 24.8509 8.74926 24.4873 8.98563 24.6146Z",
    fill: "#3B0523"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_40_49823",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20 20) rotate(90) scale(20)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.487641,
    stopColor: "#FFD3C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3663F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_40_49823",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.8214 25.0786) scale(4.0178 4.03226)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D93C0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1788,
    stopColor: "#D93C0B",
    stopOpacity: 0.8196
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4174,
    stopColor: "#D93C0B",
    stopOpacity: 0.579
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6896,
    stopColor: "#D93C0B",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#D93C0B",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_40_49823",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.3669 25.0786) scale(4.0178 4.03226)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D93C0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1788,
    stopColor: "#D93C0B",
    stopOpacity: 0.8196
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4174,
    stopColor: "#D93C0B",
    stopOpacity: 0.579
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6896,
    stopColor: "#D93C0B",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9848,
    stopColor: "#D93C0B",
    stopOpacity: 0.01
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoodPrettyGood);
export default __webpack_public_path__ + "static/media/Mood_Pretty_Good.a861d2369e73ef5fe0fb8db27128c661.svg";
export { ForwardRef as ReactComponent };